export const styles = theme => ({
  titleWrapper: {
    padding: theme.spacing(3),
    position: 'relative',
    minWidth: 500,
  },
  headerTitle: {
    fontFamily: 'AvenirNext-Medium',
    fontWeight: 500,
    color: '#3b3b3b',
    margin: theme.spacing(1, 0, 2),
  },
  closeIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    padding: 0,
  },
  settings: {
    textAlign: 'left',
  },
  leftPanel: {
    minHeight: 'calc(100vh - 250px)',
    [theme.breakpoints.down('xs')]: {
      minHeight: 0
    }
  },
  container: {
    height: 'calc(100% - 8px)',
    boxSizing: 'border-box'
  },
  wrapper: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tabs: {
    '& .MuiTabs-indicator': {
      display: 'none'
    }
  },
  tab: {
    textTransform: 'capitalize',
    '&.Mui-selected': {
      fontWeight: 700,
      borderRadius: '5px',
      backgroundColor: theme.colorTokens.secondaryContainer,
    },
    '& .MuiTab-wrapper': {
      alignItems: 'flex-start',
    }
  },
  button: {
    minWidth: 150,
    marginLeft: theme.spacing(2),
  },
  redButton: {
    backgroundColor: '#d63031',
    '&:hover': {
      backgroundColor: '#991617',
    }
  },
  addUserBtn: {
    fontWeight: 900
  },
  viewListSelection: {
    margin: theme.spacing(0, 1),
    color: theme.palette.primary.main,
    fontFamily: 'AvenirNext-Medium',
    '&.MuiInput-underline:before': {
      borderBottomColor: theme.palette.primary.main,
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main,
    }
  },
  inputLabel: {
    textTransform: 'uppercase',
    color: '#96979a',
    fontSize: 13
  },
  input: {
    '& .MuiInputBase-root': {
      backgroundColor: '#fff'
    },
    '& .MuiInputBase-input.Mui-disabled': {
      backgroundColor: '#f6f5f5'
    }
  },
  hint: {
    fontSize: 11,
    fontStyle: 'italic',
    color: '#5a5a5a',
  },
  userId: {
    fontSize: 13,
    marginLeft: theme.spacing(1)
  },
  removeTitle: {
    fontSize: '1.5em',
    fontFamily: 'AvenirNext-Medium',
  },
  error: {
    color: 'red',
  },
  errorBox: {
    '& .MuiFormHelperText-root': {
      maxWidth: 400,
      margin: "auto",
    }
  },
  tableHeader: {
    textTransform: 'uppercase',
    color: '#737273'
  },
  tableCell: {
    color: '#4a4a4a'
  },
  radioGroup: {
    justifyContent: 'space-between'
  },
  passwordWrapper: {
    marginBottom: theme.spacing(2)
  },
  viewListButton: {
    textTransform: 'capitalize',
    color: "#4a90e2",
    textDecoration: 'underline',
  }
})
